<div class="template-file-upload">
  <div class="upload-header">
    <div class="template-info">
      <h6 class="template-title">
        {{ templateName }}
        <span class="required-indicator" *ngIf="required">*</span>
      </h6>
      <small class="text-muted">
        支援格式：{{ getAcceptedFormatsText() }} | 最大 {{ maxFileSize }}MB
      </small>
    </div>

    <!-- 範本下載按鈕 -->
    <button type="button"
            class="btn btn-outline-secondary btn-sm download-btn"
            (click)="downloadTemplate()"
            *ngIf="templateUrl"
            [disabled]="disabled"
            title="在新視窗中開啟範本">
      <i class="fas fa-external-link-alt"></i>
      下載範本
    </button>
  </div>

  <!-- 檔案上傳區域 -->
  <div class="upload-area"
       [ngClass]="{
         'has-file': status === FileUploadStatus.Uploaded,
         'uploading': status === FileUploadStatus.Uploading,
         'error': status === FileUploadStatus.Error,
         'disabled': disabled
       }">

    <!-- 無檔案狀態 -->
    <div class="upload-placeholder"
         *ngIf="status === FileUploadStatus.NotUploaded"
         (click)="triggerFileSelect()">
      <div class="upload-icon">
        <i class="fas fa-cloud-upload-alt"></i>
      </div>
      <div class="upload-text">
        <p class="main-text">點擊上傳檔案</p>
        <small class="sub-text">或拖曳檔案至此處</small>
      </div>
    </div>

    <!-- 上傳中狀態 -->
    <div class="uploading-state" *ngIf="status === FileUploadStatus.Uploading">
      <div class="upload-progress">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <span class="ms-2">上傳中...</span>
      </div>
      <div class="progress mt-2">
        <div class="progress-bar"
             role="progressbar"
             [style.width.%]="uploadProgress"
             [attr.aria-valuenow]="uploadProgress"
             aria-valuemin="0"
             aria-valuemax="100">
        </div>
      </div>
    </div>

    <!-- 已上傳檔案狀態 -->
    <div class="uploaded-file" *ngIf="status === FileUploadStatus.Uploaded && selectedFile">
      <div class="file-info">
        <div class="file-icon">
          <i class="fas fa-file" [ngClass]="getFileIconClass(selectedFile)"></i>
        </div>
        <div class="file-details">
          <div class="file-name" [title]="selectedFile.name">{{ selectedFile.name }}</div>
          <div class="file-size">{{ getFileSizeString(selectedFile) }}</div>
        </div>
      </div>

      <div class="file-actions">
        <button type="button"
                class="btn btn-outline-primary btn-sm"
                (click)="previewFile()"
                [disabled]="disabled"
                title="預覽檔案">
          <i class="fas fa-eye"></i>
        </button>
        <button type="button"
                class="btn btn-outline-secondary btn-sm"
                (click)="triggerFileSelect()"
                [disabled]="disabled"
                title="替換檔案">
          <i class="fas fa-edit"></i>
        </button>
        <button type="button"
                class="btn btn-outline-danger btn-sm"
                (click)="removeFile()"
                [disabled]="disabled"
                title="移除檔案">
          <i class="fas fa-trash"></i>
        </button>
      </div>
    </div>

    <!-- 錯誤狀態 -->
    <div class="error-state" *ngIf="status === FileUploadStatus.Error">
      <div class="error-icon">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <div class="error-message">{{ errorMessage }}</div>
      <button type="button"
              class="btn btn-outline-primary btn-sm mt-2"
              (click)="triggerFileSelect()"
              [disabled]="disabled">
        重新選擇檔案
      </button>
    </div>
  </div>

  <!-- 隱藏的檔案輸入 -->
  <input type="file"
         #fileInput
         class="d-none"
         [accept]="acceptedFormats.join(',')"
         (change)="onFileSelected($event)">
</div>
